App.controller('InsuranceListCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', '$mdDialog', 'Config', 'insuranceService', 'profileService', '$timeout', 'FileSaver', 'Blob', function ($scope, $stateParams, $sce, $state, $http, $mdDialog, Config, insuranceService, profileService, $timeout, FileSaver, Blob) {
    $scope.stateParams = $stateParams;

    $scope.page = 'mypackage';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    insuranceService.last().then(function (data) {
        if (data.status === 200) {
            $scope.package = data.data;

            console.log($scope.package);

            if (!Object.keys($scope.package).length) {
                $state.go('root.home.insurance.package');
            }
        }
    });

    profileService.dataUser().then(function (data) {
        $scope.userData = data.data;
    });

    var page = 0;
    $scope.current = page;
    $scope.searchString = '';

    loadActivities(page);

    function loadActivities(page) {
        var criteria = {
            pageNumber: page,
            pageSize: 10,
            searchString: $scope.searchString
        }

        insuranceService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.activities = data.data.data;
                $scope.numberOfPages = data.data.pages;
                // $scope.buildScroll();
                // console.log($scope.activities);
            }
        });
    }

    $scope.search = function () {
        loadActivities(0);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page);
        $scope.current = page;
    };

    $scope.addProteges = function () {
        if ($scope.userData.benefit.partner || $scope.userData.benefit.children) {
            $state.go('root.home.profile_proteges.lists');
        } else {
            $scope.showPopUp('', 'Rozszerz pakiet!', 'Twój pakiet nie obejmuje opieki dla podopiecznych, rozszerzy pakiet aby dodać członków rodziny.', 'Przejdź do wyboru pakietu', 'root.home.insurance.package', 'true');
        }
    }

    $scope.showInformationPopUp = function(ev, head, content, text, target, exit, secondButtonText, secondButtonTarget) {
        $mdDialog.show({
            controller: informationPopUpCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                secondButton: {
                    text: secondButtonText,
                    target: secondButtonTarget
                }
            }
        }).then(function(data) {

        }, function() {

        })
    };

    function informationPopUpCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }



    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.buildScroll = function() {
        $timeout(function() {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    }

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis:"x",
            theme:"dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced:{autoExpandHorizontalScroll:true},
            callbacks:{
                onInit: function(){

                },
                onScroll: function(){

                }
            }
        });
    }

    $scope.getStatement = function(ev, id) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        insuranceService.getStatement(id).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'oświadczenie.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    function initCloseInsurance() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateNow.getTime() <= dateTo.getTime()) {
            $scope.showInformationPopUp(
                '',
                '',
                'Od 1 grudnia 2019 r. obowiązywać będzie nowy program ubezpieczenia zdrowotnego dla pracowników i członków ich rodzin. Aby przystąpić do nowego programu należy przejść do zakładki "Opieka medyczna".',
                'Przejdź do nowego programu',
                'root.healthInsuranceInfo.start',
                'true',
                'Rozumiem',
                '');
            return;
        }

        if (dateTo.getTime() <= dateNow.getTime()) {
            $state.go('root.health.start');
        }
    }

    initCloseInsurance();

}]);
